import React from "react";
import { makeStyles } from "@material-ui/core";
import { useSelector } from "react-redux";
import clsx from "clsx";

const useStyles = makeStyles(() => ({
	root: {
		display: "flex",
		flexDirection: "column",
	},
	minusMargin: {
		margin: "0 -1rem",
	},
}));

export function AssetWrapper({ children }) {
	const isMobile = useSelector((state) => state.theme.isMobile);
	const classes = useStyles();

	return (
		<div className={clsx(classes.root, isMobile && classes.minusMargin)}>
			{children}
		</div>
	);
}
